import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "../../../assets/css/TestimonialsSection.css";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function hasImage(value) {
  return (
    typeof value === "string" &&
    value.trim() !== "" &&
    value !== "undefined" &&
    value !== "null"
  );
}

function TestimonialsSection() {
  const [officialsData, setOfficialsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { section, id } = useParams();

  useEffect(() => {
    let active = true;

    async function fetchOfficialsData() {
      setLoading(true);
      setError(false);

      try {
        // Keep the existing Laravel CSRF-cookie request.
        await axios.get("sanctum/csrf-cookie");

        const response = await axios.get(
          `${BASE_URL}pagdata?itemName[eq]=top_manag&status02[eq]=publish`,
        );

        if (!active) return;

        if (response?.data?.status === 200) {
          setOfficialsData(
            Array.isArray(response.data.allData) ? response.data.allData : [],
          );
        } else {
          setOfficialsData([]);
          setError(true);
        }
      } catch (err) {
        if (active) {
          console.error("Error loading ministry leadership:", err);
          setOfficialsData([]);
          setError(true);
        }
      } finally {
        if (active) setLoading(false);
      }
    }

    fetchOfficialsData();

    return () => {
      active = false;
    };
  }, [section, id]);

  if (loading) {
    return (
      <section
        className="fmw-leadership-directory"
        aria-label="Ministry leadership"
      >
        <div className="container fmw-leadership-content">
          <div
            className="fmw-leadership-state"
            role="status"
            aria-live="polite"
          >
            <span className="fmw-loading-mark" aria-hidden="true" />
            <p>Loading ministry leadership...</p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section
        className="fmw-leadership-directory"
        aria-label="Ministry leadership"
      >
        <div className="container fmw-leadership-content">
          <div className="fmw-leadership-state" role="alert">
            <i className="fa-solid fa-circle-exclamation" aria-hidden="true" />
            <p>
              The leadership directory is temporarily unavailable. Please
              refresh the page to try again.
            </p>
          </div>
        </div>
      </section>
    );
  }

  if (officialsData.length === 0) return null;

  return (
    <section
      id="featured-official"
      className="fmw-leadership-directory"
      aria-labelledby="fmw-leadership-title"
    >
      <div className="fmw-leadership-background" aria-hidden="true">
        <span className="fmw-leadership-shape fmw-shape-one" />
        <span className="fmw-leadership-shape fmw-shape-two" />
        <span className="fmw-leadership-grid-mark" />
      </div>

      <div className="container fmw-leadership-content">
        <header className="fmw-directory-heading">
          <span className="fmw-directory-eyebrow">
            <span className="fmw-eyebrow-line" />
            LEADERSHIP &amp; SERVICE
            <span className="fmw-eyebrow-line" />
          </span>

          <h2 id="fmw-leadership-title">
            Our <span>Leadership</span>
          </h2>

          {/* <p>
            Meet the leadership team advancing housing and sustainable urban
            development across Nigeria.
          </p> */}

          <div className="fmw-directory-heading-rule" aria-hidden="true">
            <span />
          </div>
        </header>

        <div className="fmw-leadership-grid">
          {officialsData.map((official, index) => {
            const imageAvailable = hasImage(official.item01);
            const imageUrl = imageAvailable
              ? `${BACKEND_URL}upload/${official.item01}`
              : null;

            return (
              <article
                className="fmw-leader-card"
                key={
                  official.id || `${official.item03b || "official"}-${index}`
                }
              >
                <div className="fmw-leader-image-wrap">
                  {imageUrl ? (
                    <img
                      className="fmw-leader-image"
                      src={imageUrl}
                      alt={official.item03b || "Ministry official"}
                      loading="lazy"
                      decoding="async"
                    />
                  ) : (
                    <div
                      className="fmw-leader-image-placeholder"
                      role="img"
                      aria-label="Portrait unavailable"
                    >
                      <i className="fa-solid fa-user-tie" aria-hidden="true" />
                      <span>FMW</span>
                    </div>
                  )}

                  <span
                    className="fmw-leader-image-accent"
                    aria-hidden="true"
                  />
                  <span className="fmw-leader-photo-label">
                    OFFICIAL PROFILE
                  </span>
                </div>

                <div className="fmw-leader-card-content">
                  <span className="fmw-leader-index">
                    PROFILE {String(index + 1).padStart(2, "0")}
                  </span>

                  <h3>{official.item03b || "Ministry Official"}</h3>

                  {official.item03 && (
                    <p className="fmw-leader-designation">
                      {official.item03}
                    </p>
                  )}

                  <span className="fmw-leader-divider" aria-hidden="true" />

                  {official.linker && (
                    <p className="fmw-leader-description">
                      {official.linker}
                    </p>
                  )}

                  <div className="fmw-leader-card-footer">
                    <span
                      className="fmw-leader-footer-icon"
                      aria-hidden="true"
                    >
                      <i className="fa-solid fa-landmark" />
                    </span>
                    <span>Federal Ministry of Works</span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <footer className="fmw-directory-footer">
          <span className="fmw-directory-footer-line" aria-hidden="true" />
          <p>Federal Ministry of Works</p>
          <span className="fmw-directory-footer-line" aria-hidden="true" />
        </footer>
      </div>
    </section>
  );
}

export default TestimonialsSection;
